import { AgregatedQualificationResponse } from 'services/api/AgentCenterAPI';

export type AggregatedQualificationGroup = {
    sourceCallId: string;
    sourceCallDate: string;
    qualifications: AgregatedQualificationResponse[];
};

const NO_SOURCE_KEY = '__no_source__';

export const groupAggregatedQualifications = (
    qualifications: AgregatedQualificationResponse[]
): AggregatedQualificationGroup[] => {
    const groups = new Map<string, AggregatedQualificationGroup>();

    qualifications.forEach((qualification) => {
        const groupKey = qualification.sourceCallId || NO_SOURCE_KEY;
        const existing = groups.get(groupKey);

        if (existing) {
            existing.qualifications.push(qualification);
            return;
        }

        groups.set(groupKey, {
            sourceCallId: qualification.sourceCallId,
            sourceCallDate: qualification.sourceCallDate,
            qualifications: [qualification],
        });
    });

    return Array.from(groups.values()).sort(
        (a, b) => new Date(b.sourceCallDate).getTime() - new Date(a.sourceCallDate).getTime()
    );
};
